export const validityCardMask = (value: string): string => {
  const cleanedText = value.replace(/[^0-9]/g, '')
  let formattedText = cleanedText

  if (cleanedText.length <= 2) {
    formattedText = cleanedText
  } else {
    formattedText = cleanedText.slice(0, 2) + '/' + cleanedText.slice(2)
  }

  return formattedText
}
